import { render, staticRenderFns } from "./ProfileQualifications.vue?vue&type=template&id=3903069f&"
import script from "./ProfileQualifications.vue?vue&type=script&lang=js&"
export * from "./ProfileQualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports